import React from "react";

const NotFound = () => {


  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "15px",
        flexDirection: "column",
      }}
    >
      <h1 style={{ fontSize: "46px" }}>404 </h1>{" "}
      <p style={{ fontSize: "42px" }}>Not Found</p>
    </div>
  );
};

export default NotFound;
